module.exports = __webpack_public_path__ + "img/placeholder.f010cb0.jpg";